import { render, staticRenderFns } from "./planReport.vue?vue&type=template&id=60ffa444&"
import script from "./planReport.vue?vue&type=script&lang=js&"
export * from "./planReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports